import Insight from "../insightClass";
import React from "react";
import { insight44Media } from "../../../assets/assetReference";
import { ContactSubscribe } from "../../../components/Contact/Contact";
export const insight076 = new Insight(
  "07 November 2025",
  {
    pageTitle: "Global Offshore Wind Weekly",
    metaDescription: "WeBridge Insights, Global Offshore Wind Weekly",
    keyWords:
      "European Offshore Wind Market development, Global Offshore Wind Weekly",
  },
  {
    src: insight44Media[0],
    alt: "offshore wind turbine",
  },
  "Global Offshore Wind Weekly (2025-11-07)",
  "",
  `Ørsted has agreed to sell a 50% equity stake in the 2.9 GW Hornsea 3 project to Apollo, which will also fund half of the remaining capital expenditure. Hornsea 3—located roughly 160 km off the Yorkshire coast—remains on track for completion by end-2027 and will become the world’s largest offshore wind farm, supplying power to around three million UK homes.`,
  <div>
    <strong>WeBridge Insights</strong>
    <h1>Global Offshore Wind Weekly (2025-11-07)</h1>
    <h2></h2>
    <p className="article-date">07 November 2025</p>
    <br />
    <p>
      Welcome to this week's <i>WeBridge Insights</i>, where we provide you with
      the latest updates and key developments from the global offshore wind
      market.
    </p>
    <br />
    <br />
    <br />
    <p>
      At <b>WeBridge</b>, we deliver forward-thinking analysis and expert
      commentary to keep you informed in this fast-evolving industry. Here's our
      roundup of the top stories this week, complete with professional insights
      to help you stay ahead:
    </p>
    <h3>1. Ørsted sells 50% of Hornsea 3 to Apollo for ~$6–6.5bn</h3>
    <p>
      Ørsted has agreed to sell a 50% equity stake in the 2.9 GW Hornsea 3
      project to Apollo, which will also fund half of the remaining capital
      expenditure. Hornsea 3—located roughly 160 km off the Yorkshire
      coast—remains on track for completion by end-2027 and will become the
      world’s largest offshore wind farm, supplying power to around three
      million UK homes. The sale strengthens Ørsted’s balance sheet following
      earlier US impairments and confirms the company’s strategic focus on
      capital recycling while retaining EPC, O&M, and route-to-market roles.
      Despite challenging macroeconomic conditions, the deal demonstrates
      continued institutional appetite for de-risked UK offshore assets.
    </p>
    <p>
      <b>WeBridge Insights:</b>
    </p>
    <p>
      This transaction sets a template for structured co-ownership at
      construction stage, allowing developers to unlock value while minimising
      exposure to cost inflation. Expect similar capital-recycling partnerships
      on other late-stage European projects. For the UK supply chain, the
      investment de-risks procurement timelines through 2027, providing greater
      certainty for turbine, cable, and foundation suppliers. Policy takeaway:
      the UK’s CfD framework remains globally investable—government must now
      sustain predictability across AR7–AR8 rounds to maintain that momentum.
    </p>
    <h3>2. Dogger Bank’s lifetime UK GDP boost estimated at £6.1 bn</h3>
    <p>
      A new economic impact assessment from BVG Associates projects that the
      three-phase, 3.6 GW Dogger Bank complex—now operational—will contribute
      £6.1 bn to UK GDP over its lifetime. The study attributes the gains to
      port activity, long-term maintenance contracts, and localised component
      manufacturing. The findings highlight how large-scale offshore wind
      investments generate durable value across regional economies, particularly
      in the North East, Yorkshire, and Humber regions, while underpinning UK
      expertise in project delivery and operations.
    </p>
    <p>
      <b>WeBridge Insights:</b>
    </p>
    <p>
      Dogger Bank’s performance data will shape financial modelling assumptions
      for future North Sea mega-clusters, especially around wake losses, turbine
      reliability, and service-vessel utilisation. The GDP boost underscores the
      importance of maintaining domestic fabrication capability for blades,
      towers, and subsea cables. Continued government support for grid
      reinforcement and heavy-lift port expansion will be crucial to capture
      full long-term economic benefits.
    </p>
    <h3>
      3. UK supply chain strengthens as Steel River Quay partners with Tusk
      Lifting
    </h3>
    <p>
      Steel River Quay in Middlesbrough has signed a three-year partnership with
      Tusk Lifting to provide lifting equipment and inspection services for
      offshore wind marshalling and load-out operations. The collaboration aims
      to standardise inspection regimes, reduce turnaround times, and increase
      port efficiency during peak installation campaigns. It forms part of
      Teesside’s growing role as a hub for offshore wind logistics and component
      handling.
    </p>
    <p>
      <b>WeBridge Insights:</b>
    </p>
    <p>
      This type of mid-tier collaboration demonstrates how operational
      excellence at ports can mitigate bottlenecks in the wider supply chain.
      Improved equipment readiness and inspection discipline directly reduce
      vessel idle time and critical-path risk. Developers planning 2026–27
      campaigns should secure comparable multi-year service frameworks now, as
      UK port capacity will tighten sharply once major Round 4 projects enter
      the construction phase.
    </p>
    <h3>
      4. European industry urges faster permitting and improved auction design
    </h3>
    <p>
      Leading developers and OEMs, including Ørsted and Vestas, have urged
      European governments to accelerate offshore wind permitting, refine
      auction mechanisms, and ensure grid delivery keeps pace with project
      awards. Industry executives warn that slow permitting and exposure to
      inflation risk could deter bidding, citing recent “no-bid” rounds. Vestas
      maintains its forecast of 20–25% global offshore capacity growth annually
      to 2030 but stresses that Europe must safeguard investor confidence to
      remain competitive against Asia and the US.
    </p>
    <p>
      <b>WeBridge Insights:</b>
    </p>
    <p>
      Expect near-term bidding discipline: developers will prioritise auctions
      offering revenue stability through indexation and inflation linkage.
      Governments should publish clear connection timelines and allow cost
      pass-through for major supply-chain shocks. With the US market temporarily
      slowed by permitting reviews, European yards and vessel operators may
      benefit from steadier utilisation—provided policy adjustments restore
      margin visibility for developers.
    </p>
    <h3>
      5. Poland approves amended offshore wind bill to fast-track investment
    </h3>
    <p>
      Poland has enacted a revised offshore wind law that clarifies permitting
      procedures, enables digital resource mapping, and accelerates auction
      scheduling for Baltic Sea sites. The reforms aim to attract foreign
      capital, expand domestic manufacturing, and secure Poland’s position as a
      regional offshore wind hub. By focusing legislative support on offshore
      wind while deferring contentious onshore changes, Warsaw signals clear
      commitment to large-scale marine renewables.
    </p>
    <p>
      <b>WeBridge Insights:</b>
    </p>
    <p>
      Expect an uptick in seabed tender activity and faster project maturation
      through 2026. Investors will watch for transparent auction price-setting
      and guaranteed grid connection dates. Poland’s localisation drive favours
      OEMs and contractors establishing in-country production capacity for key
      components. For developers, early preparation of geotechnical and route
      engineering packages will be essential to remain competitive once new
      auction windows open.
    </p>
    <h3>6. Vattenfall’s Nordlicht 2 receives final planning approval</h3>
    <p>
      Vattenfall has secured full planning consent for the Nordlicht 2 project
      in the German Bight, marking another milestone toward Germany’s 2030+
      offshore expansion goals. The decision allows the developer to finalise
      supply-chain commitments for turbines, foundations, and cables while
      aligning financing with future grid-connection milestones. Nordlicht 2
      adds substantial capacity to Germany’s long-term portfolio, supporting
      both national power targets and green-hydrogen ambitions.
    </p>
    <p>
      <b>WeBridge Insights:</b>
    </p>
    <p>
      Germany’s improved permitting pace is gradually de-risking projects in its
      federal waters. Developers can now secure vessel slots and yard capacity
      earlier, a critical factor as competition intensifies across the North
      Sea. Expect growing use of hybrid revenue models combining partial CfDs
      with corporate PPAs to hedge merchant exposure. Early contracting for
      logistics assets—particularly installation vessels—will become essential
      as regional demand peaks.
    </p>
    <h3>7. Ørsted reports US tariff impact exceeding £295 m YTD</h3>
    <p>
      Ørsted’s latest interim report reveals it has incurred more than £295
      million in US tariffs this year, largely due to expanded duties on steel,
      aluminium, and other key inputs. The tariffs, originally imposed under
      Trump-era trade measures and recently broadened, have added roughly 6.5%
      to group operating costs. Combined with ongoing US project delays, the
      costs have prompted Ørsted to accelerate portfolio rationalisation and
      capital partnerships, while maintaining focus on European growth markets.
    </p>
    <p>
      <b>WeBridge Insights:</b>
    </p>
    <p>
      Rising trade barriers highlight the vulnerability of global supply chains
      for offshore wind. Developers will increasingly favour European or
      tariff-exempt sourcing strategies and build contractual flexibility into
      EPC agreements. Ørsted’s experience underscores the need for robust
      commodity and currency hedging. For suppliers, maintaining dual-region
      production capacity and adaptive logistics will become a differentiator in
      future procurement frameworks.
    </p>
    <br />
    <br />
    <br />
    <p>
      As the global offshore wind sector continues to advance, innovation,
      investments, and supportive policies are driving transformative growth. At{" "}
      <i>
        <b>WeBridge</b>
      </i>
      , we provide the expertise and insights our partners need to confidently
      navigate this evolving landscape.
    </p>
    <h3 style={{ marginTop: "200px" }}>Subscribe</h3>
    <ContactSubscribe />
  </div>,
);
